import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { RotateCcw } from 'lucide-react';
import { recoverPostApi } from '../../../../api/admin/post.api';
import { useHiddenPostManagementHook } from '../../../../hooks/admin/hiddenPost/use-hidden-post';
import { AdminButton, AdminPageHeader } from '../../ui';
import { AdminPostModCard } from '../post-moderation/AdminPostParts';

const ManagementHiddenPost = (props) => {
  const [pageNumber] = useState(1);
  const [isRefetch, setIsRefetch] = useState(false);
  const { data } = useHiddenPostManagementHook({ pageNumber, isRefetch });

  const handlePost = async (postId) => {
    try {
      await recoverPostApi(postId);
      setIsRefetch(!isRefetch);
      toast.success('Thành công');
    } catch {
      //
    } finally {
      //
    }
  };

  return (
    <div className="adm-page">
      <AdminPageHeader
        title="Bài viết bị ẩn"
        description="Bài đã bị ẩn khỏi bảng tin. Phục hồi để bài hiển thị lại."
      />
      <div className="adm-mod-grid" style={{ alignItems: 'start' }}>
        {data?.map((post, index) => (
          <AdminPostModCard
            key={post.id || index}
            post={post}
            actions={
              <AdminButton size={32} icon={<RotateCcw size={14} />} onClick={() => handlePost(post.id)}>
                Phục hồi bài viết
              </AdminButton>
            }
          />
        ))}
      </div>
    </div>
  );
};

export default ManagementHiddenPost;
